import React from "react";
import { Box, Typography, makeStyles } from "@material-ui/core";
import tokens from "../designTokens";

const useStyles = makeStyles({
  root: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gap: 10,
    padding: "40px 24px",
  },
  title: { fontFamily: tokens.fontHeading, fontWeight: 600, fontSize: 15, color: tokens.textPrimary },
  description: { fontFamily: tokens.fontBody, fontSize: 12.5, color: tokens.textSecondary, maxWidth: 340, lineHeight: 1.5 },
});

export default function EmptyState({ illustration, title, description, action, style }) {
  const classes = useStyles();
  return (
    <Box className={classes.root} style={style}>
      {illustration && <Box mb={0.5} style={{ color: tokens.textHint }}>{illustration}</Box>}
      <Typography component="div" className={classes.title}>{title}</Typography>
      {description && <Typography component="div" className={classes.description}>{description}</Typography>}
      {action && <Box mt={0.75}>{action}</Box>}
    </Box>
  );
}
